import React from "react";
import { TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const CustomTimePicker = ({
  handleInput,
  Value,
  disabled,
  weekNumber,
  height,
  width
}) => {
  const handleTimeChange = (newValue) => {
    if (newValue) {
      const utcTime = dayjs(newValue);
      const gmtHours = utcTime.format("HH:mm");
      handleInput({ hour: gmtHours, value: newValue });
    } else {
      console.log("No time selected");
    }
  };

  const shouldDisableTime = (timeValue, clockType) => {
    const time = dayjs().hour(timeValue.hour()).minute(timeValue.minute());

    let start = dayjs().hour(3).minute(30);
    let end = dayjs().hour(20).minute(30);

    if (weekNumber == 2 || weekNumber == 3) {
      start = dayjs().hour(3).minute(30);
      end = dayjs().hour(20).minute(30);
    } else {
      start = dayjs().hour(5).minute(0);
      end = dayjs().hour(20).minute(30);
    }

    if (clockType === "hours") {
      return time.isBetween(start, end, null, "[]");
    }

    if (clockType === "minutes") {
      return time.isBetween(start, end, null, "[]");
    }
    return false;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        error={false}
        sx={{
          "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: "#666666",
            backgroundColor: "transparent", 
          },
          "& .Mui-error": {
            color: "inherit",
          },
          "& .MuiOutlinedInput-root": {
            width: width,
            height: height ? height : "40px",
            fontFamily: "PoppinsMedium",
            fontSize: "clamp(10px, 4vw, 13px)",
            color: "#222222",
            backgroundColor: "transparent",
            borderRadius: "8px",
            borderColor: "none",
            border: "none",
            colorScheme: "dark",
            outline: "none"
          },
          "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#666666",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#666666", 
            backgroundColor: "transparent", 
            color: "#222222",
            fontFamily: "PoppinsMedium"
          },
          borderRadius: "10px",
          color: "#222222",
          borderColor: "#666666",
          "input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
            color: "#222222",
            fontFamily:"PoppinsMedium"
          },
          "& input::placeholder": {
            color: "#222222",
            opacity: 0.5,
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#ccc",
          },
          "& .MuiSvgIcon-root": {
            color: "#ccc",
            outline: "none",
          },
          "& .MuiClockPicker-root .Mui-selected": {
            backgroundColor: "#00FF00",
            color: "#FFF",
          },
          "& .MuiClock-root .MuiButtonBase-root": {
            color: "#FFF",
          },
        }}
        disabled={disabled}
        defaultValue={null}
        value={Value ? Value : null}
        onChange={handleTimeChange}
        shouldDisableTime={shouldDisableTime}
        InputProps={{
          placeholder: "Select Time"
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomTimePicker;
